import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IconsService } from './services/icons/icons.service';
import { environment } from 'environments/environment';
import { CometChat } from '@cometchat-pro/chat';
import { HotjarService } from './services/hotjar/hotjar.service';
import { GoogleAnalyticsService } from './services/google-analytics/google-analytics.service';
import { UserGuidingService } from './services/userguiding/userguiding.service';
import { LoadingComponent } from './components/loading/loading.component';
import { NgIf } from '@angular/common';
import { LoadingService } from './services/loading/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, LoadingComponent, NgIf],
})
export class AppComponent {
  appID: string = environment.comeChatAppId;
  region: string = environment.comeChatRegion;
  appSetting: CometChat.AppSettings = new CometChat.AppSettingsBuilder()
    .subscribePresenceForAllUsers()
    .setRegion(this.region)
    .autoEstablishSocketConnection(true)
    .build();
  /**
   * Constructor
   */
  constructor(
    private iconsService: IconsService,
    private hotjarService: HotjarService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private userGuidingService: UserGuidingService,
    public loadingService: LoadingService,
  ) {
    this.iconsService.initIcons();
  }

  ngOnInit(): void {
    CometChat.init(this.appID, this.appSetting).then(
      (initialized: boolean) => {
        console.log('Initialization completed successfully', initialized);
      },
      (error: CometChat.CometChatException) => {
        console.log('Initialization failed with error:', error);
      }
    );
    if (environment.production) {
      this.hotjarService.initHotjar(environment.hotjarSiteId.toString());
    }
    
    // Initialize Google Analytics
    if (environment.gaId) {
      this.googleAnalyticsService.initGoogleAnalytics(environment.gaId);
    }

    // Initialize UserGuiding (only in development environments)
    const isDevelopmentEnvironment = !environment.production || 
                                   environment.environmentTag === 'local' || 
                                   environment.environmentTag === 'develop';
    
    if (isDevelopmentEnvironment && environment.userGuidingAppId) {
      this.userGuidingService.initUserGuiding(environment.userGuidingAppId);
    }
  }
}
